import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Styles from './Styles';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';
import AutoComplete from '../../../GeneralUI/AutoComplete';
import ListItemText from '@material-ui/core/ListItemText';
import { saveCustom } from './../../../../Actions/General'
import { errorSetter } from '../../../../Libs';
import Utils from '../../../../Libs/utils';


class Detalleusuariosucursales extends Component {

  constructor(props) {
    super(props);
    this.setErrors = errorSetter.setErrors.bind(this);
  }

  state = {
    errorForm: false,
    errorMessage: '',
    fields: {
      Sucursal: { 'value': null, 'key': null,'visible':true }
    },
    formValidations: {
      view: ['Sucursal']
    },
    formErrors: {
      Sucursal: {}
    }
  };


  componentDidMount = () => {
    console.log(this.props.editData);
    if (this.props.editData) {
      this.fillForm(this.props.editData, this.props.setIndex)
    }
    if (this.props.datosHeader) {
      this.setState(this.props.datosHeader);
    }
    console.log(this.props.datosHeader);
  }

  fillForm = (data, index) => {
    let { fields } = this.state;

    fields["Sucursal"] = ({ 'value': data[index].Sucursal.value, 'key': data[index].Sucursal.key,'visible':true });
    
    this.setState({ fields });
  }

  handleChange = (event) => {
    let { fields } = this.state; this.setState({ fields });
    fields[event.target.id].value= event.target.value;
    fields[event.target.id].key= event.target.hasOwnProperty('text') ? event.target.text : event.target.value
    this.setState({ fields });
  }

  validateLogicaForm = async () => {
  }

  setDataValidation = (errorForm, errorMessage) => {
    this.setState({ errorForm: errorForm, errorMessage: errorMessage });
  }

  setData = async () => {
    const validations = errorSetter.validateFormFields(this.state.fields, this.state.formValidations);
    this.setState({ formErrors: validations.errors });
    if (validations.isValid && !this.state.errorForm) {
      this.props.setData(this.state.fields, this.props.editData ? this.props.setIndex : null);
    }
  }

  render = () => {
    return (
      <Paper elevation={1} className={this.props.classes.mainPaper}>
        <form className={this.props.form} onSubmit={e => e.preventDefault()}>
          <Grid container direction='row' className={this.props.classes.paperGridTitle}>
            <List component="nav">
              <ListItem>
                <ListItemText primary="Permisos X Sucursal" classes={{ primary: this.props.classes.titlelabelformwhite }} />
              </ListItem>
              {(this.state.errorForm) ?
                <ListItem>
                  <ListItemText primary={this.state.errorMessage} classes={{ primary: this.props.classes.titlelabelerrorform }} />
                </ListItem> : ''
              }
            </List>
          </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} className={this.props.classes.gridForm}>
              <AutoComplete
                id="Sucursal"
                tableName='sucursal'
                fields={['sucursal_codigo','sucursal_nombre']}
                isView={true}
                aliases={[{ value: 'ID', size: 1 }, { value: 'Nombre', size: 11 }]}
                size='xx'
                primaryField='sucursal_codigo'
                searchField='sucursal_nombre'
                placeHolder='Seleccionar Sucursal'
                onSelect={this.handleChange}
                value={this.state.fields["Sucursal"].value}
                error={this.state.formErrors['Sucursal'].error}
                helperText={this.state.formErrors['Sucursal'].errorMessage}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} >
            <Grid item xs={3} className={this.props.classes.gridForm}>

              <Button
                color='primary'
                onClick={this.setData}
              >
                Adicionar
              </Button>

            </Grid>
          </Grid>


        </form>
      </Paper>
    );
  }
}

export default withStyles(Styles, { withTheme: true })(Detalleusuariosucursales);